module.exports = __webpack_public_path__ + "static/img/PS-JC.b9258e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/PS-JC.png
// module id = qz7s
// module chunks = 1